<script>
import ExhibitorRow from "./exhibitor-row.vue"
import FavoriteMixin from "./favorite-mixin.js"

export default {
  mixins: [FavoriteMixin],
  components: {ExhibitorRow},
  props: {
    exhibitorId: {type: String, required: true},
    exhibitorType: {type: String, default: 'exhibitor'},
  },

  data() {
    return {
      exhibitor: {},
    }
  },

  watch: {
    exhibitorId: {
      handler(newValue) {
        this.fetchExhibitor()
      },
    },
  },

  created() {
    this.fetchExhibitor()
  },

  methods: {
    fetchExhibitor: function () {
      let me = this
      let params = this.$route.query.lead_id ? {lead_id: this.$route.query.lead_id} : {}
      this.$api.get(`exhibitors/${this.exhibitorId}/`, {params: params}).then(function(response) {
        me.exhibitor = response.data
      }).catch(function(error){console.error(error)})
    },

    onFavoritesChanged(sfId) {
      this.getFavorites()
      let key = `${this.exhibitorType}s`
      let favExhibitors = localStorage.getItem(key)
      favExhibitors = favExhibitors ? JSON.parse(favExhibitors) : {}
      if (favExhibitors[sfId]) {
        delete favExhibitors[sfId]
      } else {
        let exhibitor = this.exhibitors.find(exhibitor => exhibitor.sfid === sfId)
        favExhibitors[sfId] = exhibitor
      }
      localStorage.setItem(key, JSON.stringify(favExhibitors))
    },
  },


}
</script>

<template>
  <span v-if="exhibitor.company_name">
    <exhibitor-row :exhibitor="exhibitor" :listDisplay="false"
      @favorite-changed="onFavoritesChanged($event)" >

      <div v-html="exhibitor.lead.html" class="py-3"/>

    </exhibitor-row>
  </span>
  <div v-else>
    <h2 class="text-center">not found</h2>
  </div>
</template>

<style scoped>

</style>